import React from 'react';
import { MenuItem, Menu, Button, Popover } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { SearchWrapper, FilterWrapper } from 'components/styled-components';
import isEqual from 'lodash/isEqual';
import shortid from 'shortid';

const RenderedFilters = ({
  handleChangeFilter,
  active,
  filter,
  filterField,
  displayFilter,
}) => {
  return (
    <MenuItem
      onClick={() => handleChangeFilter(filter, filterField, displayFilter)}
      text={filter.label}
      key={shortid.generate()}
      active={isEqual(filter, active)}
    />
  );
};

const RenderedFilterMenu = props => {
  return (
    <Menu>
      <MenuItem text="Clear Filters" onClick={props.clearFilters} />

      <MenuItem
        text="Display Category"
        active={props.activeParent === 'Display Category'}
      >
        {props.displayCategoryFilters.map(filter => (
          <RenderedFilters
            filter={filter}
            {...props}
            filterField="displayCategoryID"
            displayFilter={`Display Category > ${filter.label}`}
            key={shortid.generate()}
          />
        ))}
      </MenuItem>
    </Menu>
  );
};

const FilterMenu = ({
  categories,
  questionStatus,
  handleChangeFilter,
  selectedFilter,
  displayFilter,
  clearFilters,
}) => {
  const displayCategoryFilters = [];
  const statusFilters = [];

  categories.forEach(filter => {
    displayCategoryFilters.push({
      label: filter.categoryName,
      value: filter.categoryID,
    });
  });

  questionStatus.forEach(filter => {
    statusFilters.push({
      label: filter.statusName,
      value: filter.versionStatusID,
    });
  });

  return (
    <SearchWrapper padding="0 1rem">
      <Popover
        content={
          <RenderedFilterMenu
            handleChangeFilter={handleChangeFilter}
            active={selectedFilter}
            activeParent={displayFilter}
            clearFilters={clearFilters}
            displayCategoryFilters={displayCategoryFilters}
            statusFilters={statusFilters}
          />
        }
        autoFocus={false}
      >
        <FilterWrapper>
          <Button
            icon={IconNames.FILTER_LIST}
            rightIcon="caret-down"
            text={displayFilter ? displayFilter : 'Filter'}
            className={`${
              displayFilter === '' ? 'light-blue' : 'filter-selected'
            }`}
            fill={true}
            alignText="left"
          />
        </FilterWrapper>
      </Popover>
    </SearchWrapper>
  );
};

export default FilterMenu;
